import { Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import { Link } from "react-router-dom";
import {
  Bars3Icon,
  ChartBarIcon,
  PhoneIcon,
  XMarkIcon,
  ChevronDownIcon,
} from "@heroicons/react/24/outline";

import icon from "../images/icon.png";
import BadgeIcon from "@mui/icons-material/Badge";

const solutions = [
  {
    name: "Dallas AV Labor",
    description:
      "Get a better understanding of where your traffic is coming from.",
    href: "neworleansavlabor",
    icon: ChartBarIcon,
  },
  {
    name: "Employment",
    description:
      "Build strategic funnels that will drive your customers to convert",
    href: "employment",
    icon: BadgeIcon,
  },
];
const callsToAction = [
  { name: "Contact Employer", href: "#", icon: PhoneIcon },
];


function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

function Navbar() {
  return (
    <Popover className="relative bg-white z-20 dark:bg-gray-900">
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex items-center justify-between border-b-2 border-gray-900 py-6 md:justify-start md:space-x-10">
          <div className="flex justify-start lg:w-0 lg:flex-1">
            <Link to="/">
              <span className="sr-only">Empire AV</span>
              <img className="h-8 w-auto sm:h-10" src={icon} alt="Logo" />
            </Link>
          </div>
          <div className="-my-2 -mr-2 md:hidden">
            <Popover.Button className="inline-flex items-center justify-center rounded-md bg-white dark:bg-gray-900 p-2 text-gray-300 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-cyan-500">
              <span className="sr-only">Open menu</span>
              <Bars3Icon className="h-6 w-6" aria-hidden="true" />
            </Popover.Button>
          </div>
          <Popover.Group as="nav" className="hidden space-x-10 md:flex">
            <Popover className="relative">
              {({ open }) => (
                <>
                  <Popover.Button
                    className={classNames(
                      open ? "text-gray-300" : "text-gray-300",
                      "group inline-flex items-center rounded-md bg-white dark:bg-gray-900 text-base font-medium hover:text-gray-300 focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2"
                    )}
                  >
                    <span>AV Labor</span>
                    <ChevronDownIcon
                      className={classNames(
                        open ? "text-gray-600" : "text-gray-400",
                        "ml-2 h-5 w-5 group-hover:text-gray-500"
                      )}
                      aria-hidden="true"
                    />
                  </Popover.Button>

                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-200"
                    enterFrom="opacity-0 translate-y-1"
                    enterTo="opacity-100 translate-y-0"
                    leave="transition ease-in duration-150"
                    leaveFrom="opacity-100 translate-y-0"
                    leaveTo="opacity-0 translate-y-1"
                  >
                    <Popover.Panel className="absolute z-10 -ml-4 mt-3 w-screen max-w-md transform px-2 sm:px-0 lg:left-1/2 lg:ml-0 lg:-translate-x-1/2">
                      <div className="overflow-hidden rounded-lg shadow-lg ring-1 ring-black ring-opacity-5">
                        <div className="relative grid gap-6 bg-white px-5 py-6 sm:gap-8 sm:p-8">
                          {solutions.map((item) => (
                            <Link
                              key={item.name}
                              to={item.href}
                              className="-m-3 flex items-start rounded-lg p-3 hover:bg-gray-50"
                            >
                              <item.icon
                                className="h-6 w-6 flex-shrink-0 text-cyan-600"
                                aria-hidden="true"
                              />
                              <Popover.Button className="text-left ml-4">
                                <p className="text-base font-medium text-gray-900">
                                  {item.name}
                                </p>
                                <p className="mt-1 text-sm text-gray-500">
                                  {item.description}
                                </p>
                              </Popover.Button>
                            </Link>
                          ))}
                        </div>
                        <div className="space-y-6 bg-gray-50 px-5 py-5 sm:flex sm:space-y-0 sm:space-x-10 sm:px-8">
                          {callsToAction.map((item) => (
                            <div key={item.name} className="flow-root">
                              <Link
                                to={item.href}
                                className="-m-3 flex items-center rounded-md p-3 text-base font-medium text-gray-900 hover:bg-gray-100"
                              >
                                <item.icon
                                  className="h-6 w-6 flex-shrink-0 text-gray-400"
                                  aria-hidden="true"
                                />
                                <span className="ml-3">{item.name}</span>
                              </Link>
                            </div>
                          ))}
                        </div>
                      </div>
                    </Popover.Panel>
                  </Transition>
                </>
              )}
            </Popover>

            <Link
              to="/pricing"
              className="text-base font-medium text-gray-300 hover:text-gray-900"
            >
              Pricing
            </Link>
            <Link
              to="contactus"
              className="text-base font-medium text-gray-300 hover:text-gray-900"
            >
              Contact
            </Link>
            <Link
              to="aboutus"
              className="text-base font-medium text-gray-300 hover:text-gray-900"
            >
              About
            </Link>

          </Popover.Group>
        </div>
      </div>

      <Transition
        as={Fragment}
        enter="duration-200 ease-out"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="duration-100 ease-in"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <Popover.Panel
          focus
          className="absolute inset-x-0 top-0 origin-top-right transform p-2 transition md:hidden"
        >
          <div className="divide-y-2 divide-gray-50 rounded-lg bg-white shadow-lg ring-1 ring-black ring-opacity-5">
            <div className="px-5 pt-5 pb-6">
              <div className="flex items-center justify-between">
                <div>
                  <img className="h-8 w-auto" src={icon} alt="Your Company" />
                </div>
                <div className="-mr-2">
                  <Popover.Button className="inline-flex items-center justify-center rounded-md bg-white p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-cyan-500">
                    <span className="sr-only">Close menu</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </Popover.Button>
                </div>
              </div>
              {/* Hamburger */}
              <div className="mt-6">
                <nav className="grid gap-y-8">
                  <Link
                    to="/pricing"
                    className="text-base font-medium text-gray-800 hover:text-gray-500"
                  >
                    <Popover.Button>Pricing</Popover.Button>
                  </Link>
                  <Link
                    to="contactus"
                    className="text-base font-medium text-gray-800 hover:text-gray-500"
                  >
                    <Popover.Button>Contact Us</Popover.Button>
                  </Link>
                  <Link
                    to="aboutus"
                    className="text-base font-medium text-gray-800 hover:text-gray-500"
                  >
                    <Popover.Button>About Us</Popover.Button>
                  </Link>
                  <Link
                    to="employment"
                    className="text-base font-medium text-gray-900 hover:text-gray-700"
                  >
                    <Popover.Button>Employment</Popover.Button>
                  </Link>
                </nav>
              </div>
            </div>
            <div className="space-y-6 py-6 px-5">
              <div>
                <a
                  href="#"
                  className="flex w-full items-center justify-center rounded-md border border-transparent bg-cyan-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-cyan-700"
                >
                  Call now
                </a>
              </div>
            </div>
          </div>
        </Popover.Panel>
      </Transition>
    </Popover>
  );
}

export default Navbar;
